import { createVendorAddressPairInputSchema } from './create-address-pair-input.js';
import { vendorAddressPairFormSchema, } from './create-pair-form.js';
export function toCreateVendorAddressPairInput(values) {
    const parsed = vendorAddressPairFormSchema.parse(values);
    const remitSameAsShipping = parsed.remitSameAsShipping !== false;
    return createVendorAddressPairInputSchema.parse({
        shipping: {
            addressName: parsed.addressName,
            address: parsed.address,
            city: parsed.city ?? null,
            stateId: parsed.stateId ?? null,
            countryId: parsed.countryId ?? null,
            zip: parsed.zip ?? null,
        },
        remitSameAsShipping,
        // The pair form's superRefine rejects an incomplete remit whenever it isn't same-as-shipping.
        remit: remitSameAsShipping ? null : parsed.remit,
    });
}
//# sourceMappingURL=to-create-vendor-address-pair-input.js.map